import { useRouter } from 'next/router';

import { ContentWrapper } from '@collab/atoms';

import PageSeo, { SeoProps } from 'libs/seo/PageSeo';
import ContributeAside from 'organisms/ContributeAside/ContributeAside';

type Props = {
  seo?: SeoProps;
  repoUrl?: string;
  children: React.ReactNode;
};

const DocLayout: React.FC<Props> = ({ seo, repoUrl, children }) => {
  const { asPath } = useRouter();

  return (
    <ContentWrapper>
      {seo && <PageSeo {...seo} />}
      {children}
      <ContributeAside repoUrl={repoUrl} feedbackUrl={asPath} />
    </ContentWrapper>
  );
};

export default DocLayout;
